module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modal",
    staticClass: "modal fade"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t("modals.selectAGroup.title")) + " ")])]), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.options.helpText) ? _c('div', {
    staticClass: "alert alert-info text-muted"
  }, [_vm._v(_vm._s(_vm.$t(_vm.options.helpText)))]) : _vm._e(), _c('select-a-group-div', {
    attrs: {
      "filter-groups": _vm.filterGroups
    },
    on: {
      "select-group": _vm.selectGroup
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-819d28b4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SelectAGroupModal.vue
// module id = 1278
// module chunks = 1